import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

export function insertPermission(url, name) {
    return Post(envConfig.formalServer + "/cotton/insertPermission", {url, name})
}

export function deletePermissionByIdList(idList) {
    return Post(envConfig.formalServer + "/cotton/deletePermissionByIdList", {idList})
}

export function updatePermission(id, url, name) {
    return Post(envConfig.formalServer + "/cotton/updatePermission", {id, url, name})
}

export function queryRoleListByPermission(permissionList) {
    return Post(envConfig.formalServer + "/cotton/queryRoleListByPermission", {permissionList})
}

/**
 * 这是一个分页查询
 */
export function selectPermissionList(id, url, name, pageNum, pageSize) {
    return Post(envConfig.formalServer + "/cotton/selectPermissionList", {id, url, name, pageNum, pageSize})
}